var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableList}},_vm._l((_vm.headerList),function(item,index){return _c('el-table-column',{key:index,attrs:{"prop":item.prop,"label":item.name,"align":"center","show-overflow-tooltip":"","min-width":index == 0?40:''}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }